import one from '../assets/svg/projects/one.png'
import two from '../assets/svg/projects/two.png'
import three from '../assets/svg/projects/three.png'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Gericht Restaurant Website',
        projectDesc: 'This design aims to provide a seamless and enjoyable experience for our customers when ordering and browsing through our menu.',
        tags: ['React', 'CSS'],
        code: 'https://github.com/farhan-sadiq-mahi/restaurant-frontend-design',
        demo: 'https://restaurant-frontend-design-1d38.vercel.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'Hoo Back Website',
        projectDesc: 'Modern unique UI for online bank service',
        tags: ['React', 'Tailwind CSS'],
        code: 'https://github.com/farhan-sadiq-mahi/hoo-bank-frontend-design',
        demo: 'https://hoo-bank-frontend-design.vercel.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Snappy Chat Web App',
        projectDesc: 'A real-time chat app built with the MERN stack cms',
        tags: ["MongoDB", 'Express', "React", 'Node.js'],
        code: 'https://github.com/farhan-sadiq-mahi/chat-app-client',
        demo: 'https://chat-app-client-nine.vercel.app/',
        image: three
    },
    {
        id: 4,
        projectName: 'Business Landing Page',
        projectDesc: 'This project involves the development of landing pages for many kind of business.',
        tags: ['Flutter', 'Firebase'],
        code: ' ',
        demo: ' ',
        image: 'https://cdn.dribbble.com/users/2328616/screenshots/16769615/media/c4c0d704d34d9424296375bf88841575.png?compress=1&resize=768x576&vertical=top'
    },
    {
        id: 5,
        projectName: 'E-Commerce App',
        projectDesc: 'A Simple Interiors E-commerce application',
        tags: ['React', 'Tailwind', 'Node', 'Firebase'],
        code: ' ',
        demo: ' ',
        image: 'https://cdn.dribbble.com/users/737304/screenshots/17727366/media/7453df86b79b332e939edc6ecbb9c1a4.png?compress=1&resize=768x576&vertical=top'
    },
    {
        id: 6,
        projectName: 'Unique Car Rental',
        projectDesc: 'Uber clone',
        tags: ['MERN', "tailwind", 'Firebase'],
        code: ' ',
        demo: ' ',
        image: 'https://cdn.dribbble.com/users/1963775/screenshots/16218831/media/6e5dcd51c07d11345b3f4b19b1091bcc.png?compress=1&resize=768x576&vertical=top'
    },
    {
        id: 7,
        projectName: 'Stock Market App',
        projectDesc: 'A simple stock market API app',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: ' ',
        demo: ' ',
        image: 'https://cdn.dribbble.com/users/7417866/screenshots/16783843/media/80cd7c5f5458e71228a7b14824422afd.png?compress=1&resize=768x576&vertical=top'
    },
    {
        id: 8,
        projectName: 'Pine SaaS Design',
        projectDesc: 'Saas website design',
        tags: ['Flutter', 'React'],
        code: ' ',
        demo: ' ',
        image: 'https://cdn.dribbble.com/users/2328616/screenshots/16784179/media/b0fa9241dc647cbdd8a2b1a92ecb44ff.png?compress=1&resize=768x576&vertical=top'
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/